import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import checkForPrizes from "@/assets/checkForPrizes.svg";
import buyTickets from "@/assets/buyTickets.svg";
import waitForTheDraw from "@/assets/waitForTheDraw.png";
import dollar from "@/assets/dollar.svg";
import Countdown from "react-countdown";

const WinningDetails = ({ data }) => {
  var classes = {
    content: {
      background: "#050518",
      borderRadius: "25.2165px",
    },
  };
  var center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const [countdownDate, setCountdownDate] = useState<Date | undefined>(undefined);

  useEffect(() => {
    if (data?.firstupComRecords?.[0]?.lotteryDrawDate) {
      setCountdownDate(
        new Date(data.firstupComRecords[0].lotteryDrawDate)
      );
    }
  }, [data]);
  return (
    <Grid
      container
      display={"flex"}
      direction={"row"}
      justifyContent={"flex-around"}
    >
      <Grid item xs={12} sm={12} md={12}>
        <Typography
          component="h4"
          variant="h4"
          sx={{
            marginBottom: { xs: "10px", md: "20px", lg: "30px" },
            marginTop: { xs: "15px", md: "30px", lg: "40px" },
            fontSize: { xs: "16px", md: "20px", lg: "24px" },
          }}
        >
          Start winning today
        </Typography>
        <Grid
          container
          display={"flex"}
          direction={"row"}
          spacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
          justifyContent={"start"}
          alignItems={"center"}
        >
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <a
              href="/auth/login"
              style={{
                display: "block",
                width: "100%",
                textDecoration: "none",
              }}
            >
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                style={classes.content}
              >
                <CardContent>
                  <Stack
                    spacing={2}
                    flex="1 0 100%"
                    justifyContent={center}
                    alignItems={center}
                  >
                    <Box>
                      {" "}
                      <img
                        src={buyTickets}
                        alt="buyTickets"
                        style={{ textAlign: "center" }}
                        width="89px"
                        height="89px"
                        loading="lazy"
                      />
                    </Box>

                    <Box>
                      <Typography
                        component="h4"
                        variant="h4"
                        sx={{
                          fontSize: {
                            xs: "12px !important",
                            md: "15px !important",
                          },
                          fontWeight: "500",
                        }}
                      >
                        BUY TICKETS
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          opacity: "0.7",
                          textAlign: "center",
                          fontSize: {
                            xs: "11px !important",
                            md: "16px !important",
                          },
                        }}
                      >
                        Buy your tickets <br />
                        from 1 dollar /USDC
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </a>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <a
              href="/auth/login"
              style={{
                display: "block",
                width: "100%",
                textDecoration: "none",
              }}
            >
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                style={classes.content}
              >
                <CardContent>
                  <Stack
                    spacing={2}
                    flex="1 0 100%"
                    justifyContent={center}
                    alignItems={center}
                  >
                    <Box>
                      {" "}
                      <img
                        src={waitForTheDraw}
                        alt="buyTickets"
                        style={{ textAlign: "center" }}
                        width="89px"
                        height="89px"
                        loading="lazy"
                      />
                    </Box>

                    <Box>
                      <Typography
                        component="h4"
                        variant="h4"
                        sx={{
                          fontSize: {
                            xs: "12px !important",
                            md: "15px !important",
                          },
                          fontWeight: "500",
                        }}
                      >
                        WAIT FOR THE DRAW
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          opacity: "0.7",
                          textAlign: "center",
                          fontSize: {
                            xs: "11px !important",
                            md: "16px !important",
                          },
                        }}
                      >
                        Wait for the next live draw at <br />
                        <span>
                          {countdownDate ? (
                            <Countdown date={countdownDate} />
                          ) : ("00:00:00:00")}

                        </span>
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </a>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <a
              href="/auth/login"
              style={{
                display: "block",
                width: "100%",
                textDecoration: "none",
              }}
            >
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                style={classes.content}
              >
                <CardContent>
                  <Stack
                    spacing={2}
                    flex="1 0 100%"
                    justifyContent={center}
                    alignItems={center}
                  >
                    <Box>
                      {" "}
                      <img
                        src={checkForPrizes}
                        alt="buyTickets"
                        style={{ textAlign: "center" }}
                        width="89px"
                        height="89px"
                        loading="lazy"
                      />
                    </Box>

                    <Box>
                      <Typography
                        component="h4"
                        variant="h4"
                        sx={{
                          fontSize: {
                            xs: "12px !important",
                            md: "15px !important",
                          },
                          fontWeight: "500",
                        }}
                      >
                        CHECK FOR PRIZES
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          opacity: "0.7",
                          textAlign: "center",
                          fontSize: {
                            xs: "11px !important",
                            md: "16px !important",
                          },
                        }}
                      >
                        Discover if you won a prize <br />
                        in the last lotteries.
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </a>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Box
          sx={{
            backgroundColor: "rgba(5, 5, 24, 0.8)",
            borderRadius: "10px",
            my: { xs: "10px", md: "30px" },
            p: { xs: "20px", sm: "30px" },
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Typography component="h4" variant="h4">
                Winning Prize Details
              </Typography>

              <Typography
                component="h6"
                variant="h6"
                sx={{
                  opacity: 0.85,
                  mt: "25px",
                  whiteSpace: "pre-line",
                  lineHeight: 1.8,
                }}
              >
                🎉 <strong>Winning Big Starts Here!</strong>{"\n"}
                At <strong>MervCryptoFortune</strong>, 80% of all ticket sales go straight into the prize pool – making it one of the highest paying lotteries in the world.{"\n"}
                💰 <strong>Main Prize</strong> – Awarded to the lucky draw winner.{"\n"}
                💥 <strong>PowerBall Jackpot</strong> – Activated players can win the mega prize by matching both their lucky number and chosen color!{"\n"}
                More players, bigger prizes – and every spin could change your life.{"\n"}
                🎯 <strong>Will your ticket be the next big winner?</strong>
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>

              <Typography component="h4" variant="h4">
                🎟️ How to Play Merv’s Lottery
              </Typography>

              <Typography
                component="h6"
                variant="h6"
                sx={{
                  opacity: 0.85,
                  mt: "25px",
                  whiteSpace: "pre-line",
                  lineHeight: 1.9,
                }}
              >
                Playing is easy – winning is thrilling!

                {"\n"}💸 <strong>Buy an NFT Ticket</strong> – Each ticket gives you a shot at the prize pool.

                {"\n"}🔢 <strong>Let Merv Pick Your Numbers</strong> – Once ticket sales close, Merv (with a little help from blockchain magic) assigns a random lucky number to your NFT ticket.

                {"\n"}🎨 <strong>Activate PowerBall (Optional)</strong> – Pick a color for a chance at the Mega Jackpot.

                {"\n"}⏳ <strong>Wait for the Draw</strong> – A certified smart contract selects the winners – 100% fair, transparent, and automated.

                {"\n"}🏆 <strong>Win & Celebrate</strong> – Winnings go straight to your wallet. No middlemen. No delays.

                {"\n"}🎩 With Merv at the helm, luck has never looked so fair! Ready to take your shot?
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default WinningDetails;
